import React from 'react';
import { formatInterval } from '../utils/srsAlgorithm';
import './DifficultyRating.css';

export const DifficultyRating = ({ onRate, isFlipped, nextIntervals }) => {
  if (!isFlipped) {
    return null;
  }

  const ratings = [
    { key: 'again', label: 'Again', emoji: '❌', color: 'red' },
    { key: 'hard', label: 'Hard', emoji: '😓', color: 'orange' },
    { key: 'medium', label: 'Good', emoji: '👍', color: 'green' },
    { key: 'easy', label: 'Easy', emoji: '😄', color: 'blue' }
  ];

  return (
    <div className="difficulty-rating">
      <div className="rating-title">How well did you know this?</div>
      <div className="rating-buttons">
        {ratings.map(rating => (
          <button
            key={rating.key}
            className={`rating-btn rating-${rating.color}`}
            onClick={() => onRate(rating.key)}
          >
            <span className="rating-emoji">{rating.emoji}</span>
            <span className="rating-label">{rating.label}</span>
            {nextIntervals && nextIntervals[rating.key] && (
              <span className="rating-interval">
                {formatInterval(nextIntervals[rating.key])}
              </span>
            )}
          </button>
        ))}
      </div>
      <div className="rating-hint">
        <span className="hint-item"><kbd>1</kbd> Again</span>
        <span className="hint-item"><kbd>2</kbd> Hard</span>
        <span className="hint-item"><kbd>3</kbd> Good</span>
        <span className="hint-item"><kbd>4</kbd> Easy</span>
      </div>
    </div>
  );
};
